import { AbstractInteractorTool } from './tools';
import { EditRoomElement } from './../cmd/EditRoomElement';
import { RoomElementSnapping } from './RoomElementSnapping';
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
export class MoveLineHill extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mCommand = null;
    }
    initialize(pRoomElement) {
        this.mRoomElement = pRoomElement;
        this.mCommand = new EditRoomElement(this.mRoomManager, this.mRoomElement);
        this.mRESnapping = new RoomElementSnapping(this.mRoomManager);
        this.mRoomElement.setToolRunning(true);
        this.mRoomElement.setTransformStatus("Transform");
        this.mRoomElement.updateGeometry(false, false);
        this.prepareSnapping();
        this.mRoomManager.beginInteraction();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        this.mRoomElement.setMeshVisibility(1);
        this.mRoomManager.endInteraction();
        super.stop();
    }
    handlePointerMove(pEvent, pState) {
        this.mMouseMoved = true;
        if (!pState.isPrimaryPointer(pEvent))
            return;
        let tPointer = pState.pointers.get(pEvent.pointerId);
        if (tPointer == null)
            return;
        let tPos = this.getPlanePickPos2d_Hill(tPointer.position);
        if (tPos != null) {
            this.updatePointerPosition(tPos);
            this.validate();
            this.updateFeedback();
        }
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        //
    }
    updatePointerPosition(pPos) {
        let tDiff = pPos.subtract(this.mRoomElement.node.position.clone());
        tDiff.y = 0;
        this.mRoomElement.Params.hillTopOffset = tDiff;
        this.mRoomElement.updateGeometry(false, false);
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    finish() {
        this.mRoomElement.setTransformStatus("");
        this.mRoomElement.setToolRunning(false);
        this.mRoomElement.notifyChange(ElementChangedFlags.PropertyValues);
        this.mRoomElement.notifyChange(ElementChangedFlags.Properties);
        this.mRoomElement.notifyChange(ElementChangedFlags.BoundingBox);
        this.mRoomElement.updateGeometry();
        this.mRoomManager.setTransformationDepth(0);
        if (this.mCommand !== null) {
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mRoomManager.TransformShape();
                this.mCommand = null;
                this.stop();
            });
        }
    }
    prepareSnapping() {
        super.prepareSnapping();
        this.mRESnapping.prepareSnapping(this.mRoomElement);
    }
    prepareFeedback() {
        super.prepareFeedback();
        // this.mLengthFeedback = new RoomElementInteractors(this.mRoomManager, this.mRoomElement);
        // this.mLengthFeedback.showInteractors(false, true);
        // this.mLengthFeedback.manager.fixedView = this.mView;
    }
    updateFeedback() {
        super.updateFeedback();
        this.mRoomElement.showInteractors(false, true);
        // if (this.mLengthFeedback != null){
        //     this.mRoomElement.setInteractorVisible(true);
        //     this.mLengthFeedback.showInteractors(false, true);
        // }
    }
    clearFeedback() {
        super.clearFeedback();
        // if (this.mLengthFeedback != null) {
        //     this.mLengthFeedback.clear();
        //     this.mLengthFeedback = null;
        // }
    }
    performSnapping(pPos) {
        return (this.mRESnapping.snap(pPos, this.mView));
    }
}
